<template>
  <div class="col-12 q-pa-none">
    <q-card flat>
      <q-card-section>
        <q-form>
          <div class="row">
            <div class="col-sm-12 col-xs-12 q-pr-sm">
              <q-input dense v-model="pergunta.pergunta" label="Pergunta" />
            </div>
            <div class="col-sm-6 col-xs-12">
              <q-select
                dense
                v-model="pergunta.tipo"
                emit-value
                map-options
                label="Tipo"
                :options="tipos"
              />
            </div>
          </div> 
          <div class="row">
            <div class="col-sm-4 col-xs-12">
              <q-checkbox left-label v-model="pergunta.required" label="Obrigatório" />
            </div>
          </div>        
          <div class="row" v-if="pergunta.tipo !== 'text'">
            <div class="col-12">
              <q-table
                dense
                title="Opções de resposta"
                :data="pergunta.opcoes"
                :columns="columns"
                hide-header
              >
                <template v-slot:top-row>
                  <q-input
                    v-model="opcao"
                    dense
                    label="Nova opção"
                    class="q-ma-sm"
                    @keydown.enter="addOpcao"
                  >
                    <template v-slot:append>
                      <q-btn round dense flat icon="add" @click="addOpcao" />
                    </template>
                  </q-input>
                </template>
                <template v-slot:body-cell-remover="props">
                  <q-td class="text-right">
                    <q-btn icon="delete" flat dense round color="red" @click="removeOpcao(props.row)" />
                  </q-td>
                </template>
              </q-table>
            </div>
          </div>        
        </q-form>
      </q-card-section>
      <q-card-actions>
        <q-btn @click="addPergunta" :disable="disableBtn" label="Adicionar" color="primary" class="full-width" />
      </q-card-actions>
    </q-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tipos: [
        { label: 'Múltipla escolha', value: 'check' },
        { label: 'Única', value: 'radio' },
        { label: 'Texto', value: 'text' }
      ],
      columns: [
        { name: 'text', field: 'text', label: 'Opção', align: 'left' },
        { name: 'remover', field: 'remover', label: 'Remover', align: 'right' }
      ],
      pergunta: {
        pergunta: '',
        tipo: 'radio',
        required: true,
        opcoes: []
      },
      opcao: ''
    }
  },

  methods: {
    addOpcao () {
      if (!this.opcao || this.pergunta.opcoes.find(x => x.text.toLowerCase() === this.opcao.toLowerCase())) return
      this.pergunta.opcoes = [
        ...this.pergunta.opcoes,
        { text: this.opcao }
      ]
      this.opcao = ''
    },

    removeOpcao (opcao) {
      this.pergunta.opcoes = this.pergunta.opcoes
        .filter(x => x.text !== opcao.text)
    },

    addPergunta () {
      const opcoes = this.pergunta.tipo === 'text' ? [] : this.pergunta.opcoes.map(x => x.text)
      const pergunta = {
        ...this.pergunta,
        opcoes
      }
      this.$emit('on-add', pergunta)
    }
  },

  computed: {
    disableBtn () {
      return !this.pergunta.pergunta || (this.pergunta.tipo !== 'text' && !this.pergunta.opcoes.length)
    }
  }
}
</script>